import { useState, useEffect } from "react"
import { Link, useSearchParams } from "react-router-dom"
import toast from "react-hot-toast";
import LoaderIcon from 'react-loading-icons'
import api from "../components/api";


interface iClientes {

    cliente_id: number,
    nomeFantasia: string,
    cnpj: string,

}

interface iResumo {

    qtdAVencer: number,
    valorAVencer: number,
    qtdAberto: number,
    valorAberto: number,
    qtdPago: number,
    valorPago: number,
    qtdTotal: number,
    valorTotal: number,

}

interface iCorretor {

    corretor_id: number,
    nomeCorretor: string,
    qtdTotal: number,
    qtdPago: number,
    qtdAberto: number,
    valorPago: number,
    valorAberto: number,
    valorTotal: number,

}


const moeda = (valor: number | null | undefined) => Number(valor || 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })


// porta dos relatórios crm_rel_financeiro.asp (Resumo) e crm_rel_financeiro_garantias_corretor.asp (Por corretor)
const RelatorioFinanceiro = () => {

    const [searchParams] = useSearchParams()
    const tipo = searchParams.get('tipo') == 'corretor' ? 'corretor' : 'resumo'

    const [cliente_id, setCliente_id] = useState<number | undefined>()
    const [clientes, setClientes] = useState<[]>([])

    const [resumo, setResumo] = useState<iResumo | undefined>()
    const [corretores, setCorretores] = useState<iCorretor[]>([])
    const [carregando, setCarregando] = useState<boolean>(false)


    const dadosUsuarios = sessionStorage.getItem('dadosUsuarios')

    useEffect(() => {

        if (dadosUsuarios) {

            var dados = JSON.parse(dadosUsuarios)

            setClientes(dados.clientes)
            setCliente_id(dados.clientes.length == 1 ? dados.clientes[0].cliente_id : localStorage.getItem('cliente_id') ? Number(localStorage.getItem('cliente_id')) : undefined)

        }

    }, [dadosUsuarios])


    const consulta = async () => {

        if (!cliente_id) {
            return false
        }

        setCarregando(true)

        try {

            if (tipo == 'resumo') {

                const response = await api.post('relFinanceiroResumo', { cliente_id: cliente_id })
                setResumo(response.data)

            } else {

                const response = await api.post('relFinanceiroPorCorretor', { cliente_id: cliente_id })
                setCorretores(response.data)

            }

        } catch (err) {
            console.error(err)
            toast.error('Erro ao gerar relatório')
        } finally {
            setCarregando(false)
        }

    }

    useEffect(() => {

        consulta()

    }, [cliente_id, tipo])


    const linkGarantia = (params: string) => `/Relatorio/Garantias?${params}`


    const totais = corretores.reduce((t, rs) => ({
        qtdTotal: t.qtdTotal + rs.qtdTotal,
        qtdPago: t.qtdPago + rs.qtdPago,
        qtdAberto: t.qtdAberto + rs.qtdAberto,
        valorPago: t.valorPago + Number(rs.valorPago || 0),
        valorAberto: t.valorAberto + Number(rs.valorAberto || 0),
        valorTotal: t.valorTotal + Number(rs.valorTotal || 0),
    }), { qtdTotal: 0, qtdPago: 0, qtdAberto: 0, valorPago: 0, valorAberto: 0, valorTotal: 0 })


    return (

        <div>

            <div className="page-breadcrumb d-none d-sm-flex align-items-center mb-3">
                <div className="breadcrumb-title pe-3">Relatório</div>
                <div className="ps-3">
                    <nav aria-label="breadcrumb">
                        <ol className="breadcrumb mb-0 p-0">
                            <li className="breadcrumb-item">Financeiro</li>
                            <li className="breadcrumb-item active" aria-current="page">{tipo == 'resumo' ? 'Resumo' : 'Por corretor'}</li>
                        </ol>
                    </nav>
                </div>
            </div>

            <div className="row g-3">

                <div className="col-md-4">
                    <label className="form-label">Afiançadora</label>
                    <select className="form-control" value={cliente_id} disabled={clientes.length > 1 ? false : true} onChange={event => setCliente_id(event.target.value ? Number(event.target.value) : undefined)} >
                        {clientes.length > 1 && (<option value="">[Selecione]</option>)}
                        {
                            clientes.map((rs: iClientes) =>
                                <option key={rs.cliente_id} value={rs.cliente_id}>{rs.cnpj} - {rs.nomeFantasia}</option>
                            )
                        }
                    </select>
                </div>

                <div className="col-12">

                    <center>
                        <LoaderIcon.Puff stroke="#000" style={{ display: carregando ? 'block' : 'none' }} />
                    </center>

                    {
                        !carregando && tipo == 'resumo' && resumo && (

                            <div className="card">
                                <div className="card-body table-responsive">
                                    <table className="table table-striped align-middle mb-0">
                                        <thead>
                                            <tr>
                                                <th></th>
                                                <th className="text-center">Quantidade</th>
                                                <th className="text-end">Total em reais</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td><Link to={linkGarantia('filtro=aVencer')}>Garantias a vencer (a partir de hoje):</Link></td>
                                                <td className="text-center">{resumo.qtdAVencer || 0}</td>
                                                <td className="text-end">{moeda(resumo.valorAVencer)}</td>
                                            </tr>
                                            <tr>
                                                <td><Link to={linkGarantia('filtro=naoPagas')}>Garantias em aberto:</Link></td>
                                                <td className="text-center">{resumo.qtdAberto || 0}</td>
                                                <td className="text-end">{moeda(resumo.valorAberto)}</td>
                                            </tr>
                                            <tr>
                                                <td><Link to={linkGarantia('filtro=pagas')}>Garantias pagas:</Link></td>
                                                <td className="text-center">{resumo.qtdPago || 0}</td>
                                                <td className="text-end">{moeda(resumo.valorPago)}</td>
                                            </tr>
                                            <tr className="fw-bold">
                                                <td><Link to={linkGarantia('filtro=todas')}>Garantias (total):</Link></td>
                                                <td className="text-center">{resumo.qtdTotal || 0}</td>
                                                <td className="text-end">{moeda(resumo.valorTotal)}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>

                        )
                    }

                    {
                        !carregando && tipo == 'corretor' && corretores.length > 0 && (

                            <div className="card">
                                <div className="card-body table-responsive">
                                    <table className="table table-striped align-middle mb-0">
                                        <thead>
                                            <tr>
                                                <th>Corretor</th>
                                                <th className="text-center">Quantidade</th>
                                                <th className="text-center">Pagas</th>
                                                <th className="text-center">Em aberto</th>
                                                <th className="text-end">Valor (pagas)</th>
                                                <th className="text-end">Valor (em aberto)</th>
                                                <th className="text-end">Valor (geral)</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                corretores.map((rs) =>
                                                    <tr key={rs.corretor_id}>
                                                        <td>{rs.nomeCorretor}</td>
                                                        <td className="text-center"><Link to={linkGarantia(`filtro=porCorretor&corretor_id=${rs.corretor_id}`)}>{rs.qtdTotal}</Link></td>
                                                        <td className="text-center"><Link to={linkGarantia(`filtro=porCorretor&corretor_id=${rs.corretor_id}&pago=1`)}>{rs.qtdPago}</Link></td>
                                                        <td className="text-center"><Link to={linkGarantia(`filtro=porCorretor&corretor_id=${rs.corretor_id}&pago=0`)}>{rs.qtdAberto}</Link></td>
                                                        <td className="text-end">{moeda(rs.valorPago)}</td>
                                                        <td className="text-end">{moeda(rs.valorAberto)}</td>
                                                        <td className="text-end">{moeda(rs.valorTotal)}</td>
                                                    </tr>
                                                )
                                            }
                                        </tbody>
                                        <tfoot>
                                            <tr className="fw-bold">
                                                <td className="text-end">Total Geral</td>
                                                <td className="text-center">{totais.qtdTotal}</td>
                                                <td className="text-center">{totais.qtdPago}</td>
                                                <td className="text-center">{totais.qtdAberto}</td>
                                                <td className="text-end">{moeda(totais.valorPago)}</td>
                                                <td className="text-end">{moeda(totais.valorAberto)}</td>
                                                <td className="text-end">{moeda(totais.valorTotal)}</td>
                                            </tr>
                                        </tfoot>
                                    </table>
                                </div>
                            </div>

                        )
                    }

                </div>

            </div>

        </div>

    )

}

export default RelatorioFinanceiro
